import { AuthService } from 'src/app/services/auth.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {


  constructor(public authService: AuthService) { }
  
  async canActivate(next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {
    if(!await this.authService.checkMe()) {
      this.authService.redirecto = state.url;
      window.location.href='#/login';
      return false;
    }
    return true;
  }
}
